import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=14a2d8d0&scoped=true"
import script from "./sync.vue?vue&type=script&lang=js"
export * from "./sync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2d8d0",
  null
  
)

export default component.exports